import { WOOFZ_VC6 } from 'nove8/constants/root-constants'
import { getDogProfile } from 'nove8/helpers/api/getDogProfile'
import { useEffect, useMemo } from 'react'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useGetDogProfile = (): void => {
  const cohort = useZustandStore(
    (state) => state.lead?.cohort || state.initialCohort,
  )
  const language = useZustandSessionStore((state) => state.language)
  const isVC6Cohort = useMemo(() => cohort === WOOFZ_VC6, [cohort])

  useEffect(() => {
    if (!language || !isVC6Cohort) return

    getDogProfile()
  }, [cohort, language, isVC6Cohort])
}
